import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DateTimeService} from '@services/date-time/date-time.service';

@Component({
    selector: 'scitis-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    standalone: false
})
export class DateTimePickerComponent implements OnInit, OnChanges {

  @Input() textLabel: string = '';
  @Input() setChangeValue: boolean = false;
  @Input() showRequiredFieldIndicator: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() isDisabled: boolean = false;
  @Input() showRequiredMessage: boolean = false;
  @Input() datePickerErrorMessage: string = '';
  @Input() timePickerErrorMessage: string = '';
  @Input() submitted: boolean = false;
  @Input() startDate: any;
  @Input() startTime: any;
  @Input() setValidators: boolean = false;
  @Input() isDateValid: boolean = false;
  @Input() showSeconds: boolean = false;
  @Input() showTimeComponent: boolean = true;
  @Input() useMaxDate: boolean = false;

  @Output() focusOut: EventEmitter<any> = new EventEmitter<any>();

  dateTimeFormat: string = 'yyyy-MM-dd HH:mm:ss';
  defaultTime = {hour: 'HH', minute: 'MM', second: 'SS'};
  dateTimeForm: UntypedFormGroup = this.formBuilder.group({});
  maxDate: any;

  constructor(private formBuilder: UntypedFormBuilder,
              private dateTimeService: DateTimeService) {
  }

  get formControls() {
    return this.dateTimeForm.controls;
  }

  ngOnInit() {
    if (this.useMaxDate) {
      const currentDate = new Date();
      this.maxDate = {year: currentDate.getFullYear(), month: currentDate.getMonth(), day: currentDate.getDate()};
    }
    this.determineDateTimeFormat();

    this.dateTimeForm = this.formBuilder.group({
      date: new UntypedFormControl({value: this.startDate, disabled: this.isDisabled}),
      time: new UntypedFormControl({value: this.startTime, disabled: this.isDisabled}, [this.dateTimeService.timePickerValidator(this.defaultTime)])
    });
    if (this.setValidators) {
      this.dateTimeForm.controls.date.setValidators(Validators.required);
      this.dateTimeForm.controls.time.setValidators([Validators.required, this.dateTimeService.timePickerValidator(this.defaultTime)]);
    }
    this.onFocusOut();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.startDate) {
      if (this.setValidators && this.isDateValid) {
        this.dateTimeForm.controls.date.setErrors(null);
      }
      if (changes.startDate.previousValue && this.setChangeValue) {
        this.dateTimeForm.controls.date.setValue(changes.startDate.currentValue);
      }
    }

    if (changes && changes.startTime && changes.startTime.previousValue && this.setChangeValue) {
      this.dateTimeForm.controls.time.setValue(changes.startTime.currentValue);
    }

    if (changes && changes.isDisabled && !changes.isDisabled.firstChange) {
      if (changes.isDisabled.currentValue === true) {
        this.formControls.date.disable();
        this.formControls.time.disable();
      } else {
        this.formControls.date.enable();
        this.formControls.time.enable();
      }
    }
  }

  onChooseNowChange() {
    const now = new Date();
    const dateNow: string = String(now.getTime());
    const time = {
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: now.getSeconds()
    };
    this.dateTimeForm.controls.date.setValue(dateNow);
    this.dateTimeForm.controls.time.setValue(time);
    this.onFocusOut();
  }

  onFocusOut() {
    let time = this.dateTimeForm.controls.time.value;
    if (!this.showTimeComponent) {
      time = {
        hour: 0,
        minute: 0,
        second: 0
      };
    }

    this.focusOut.emit({
      date: this.dateTimeForm.controls.date.value,
      time: time
    });
  }

  private determineDateTimeFormat() {
    if (!this.showTimeComponent) {
      this.dateTimeFormat = 'yyyy-MM-dd';
    } else if (!this.showSeconds) {
      this.dateTimeFormat = 'yyyy-MM-dd HH:mm';
    } else {
      this.dateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
    }
  }

}
